export const BOOKED = 0
export const WAIT_ACCEPT = 1
export const CANCELED = 2
export const WAIT_PASS = 3
export const REFUSED = 4
export const HAS_CHECKOUT_NEEDS_RATING = 5
export const HAS_CHECKOUT = 6
